import { Drawer, List, ListItem, ListItemIcon } from "@material-ui/core"
import { HomeOutline } from 'react-ionicons'
import { SwapHorizontalOutline } from 'react-ionicons'
import { Link } from "react-router-dom"

const SideBarMenu = props => {
  return (
    <Drawer anchor="left" open={props.show} onClose={props.onClose}>
      <List>
        <Link to="/" style={{textDecoration: 'none', color: 'black'}}>
          <ListItem button>
            <ListItemIcon>
              <HomeOutline/>
            </ListItemIcon>
              Icons
          </ListItem>
        </Link>
        <Link to="/migration-v3-to-v4" style={{textDecoration: 'none', color: 'black'}}>
          <ListItem button>
            <ListItemIcon>
              <SwapHorizontalOutline />
            </ListItemIcon>
            Migration from v3 to v4
          </ListItem>
        </Link>
      </List>
    </Drawer>
  )
}

export default SideBarMenu